import _ from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { MultiSelectItem } from "../../../components/multi-select";
import { setPlayFilter } from "../../../redux/slices";
import { CustomTeams } from "./CustomTeams/custom-teams";
import LeagueTeams from "./league-teams";
import styles from "./teams.tab.module.scss";

export const Teams = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigateToTeam = ({ id, label }: MultiSelectItem) => {
    dispatch(
      setPlayFilter({
        selectedTeam: { id, label },
        selectedSeason: undefined,
        selectedSeries: undefined,
        selectedTag: undefined,
        selectedPlayNameFilter: undefined,
      })
    );
    navigate({ pathname: "/home/draw" });
  };

  return (
    <div className={styles.teamsPageContainer}>
      <CustomTeams handleClickPlayCount={handleNavigateToTeam} />
      <LeagueTeams handleClickPlayCount={handleNavigateToTeam} />
    </div>
  );
};
